import { render } from "./markettrendsoverview.vue?vue&type=template&id=0314cf8b"
import script from "./markettrendsoverview.js?vue&type=script&lang=js"
export * from "./markettrendsoverview.js?vue&type=script&lang=js"

import "./markettrendsoverview.vue?vue&type=style&index=0&id=0314cf8b&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__